/* eslint-disable */
function imgReload () {
  let imgHeight = 0
  let wtmp = $("#b06").width();
  let htmp = $("#b06").height();

  $("#b06 ul li").each(function() {
    let liCnt = $("#b06 ul li").length;
    let liWid = 100/liCnt;
    $(this).css({
      width: liWid + "%"
    });
  });

  $(".sliderimg").each(function() {
    imgHeight = htmp;
    $(this).css({
      width: '100%',
      height: imgHeight + 'px'
    });
  });

  $("#b06").css({
    width: "100%"
  });
}

$(window).resize(function() {
  imgReload();
});

$(document).ready(function(e) {
  imgReload();
  var unslider06 = $('#b06').unslider({dots: true, fluid: true}),
    data06 = unslider06.data('unslider');
  $('.unslider-arrow06').click(function() {
    var fn = this.className.split(' ')[1];
    data06[fn]();
  });
});



// WEBPACK FOOTER //
// ./static/jqueryplugins/slide.js